import dayjs from "dayjs";
import { useEffect, useState } from "react";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

const TICK_INTERVAL = 50;

export interface TimeKeeperProps {
    start: string,
    duration: number,
    remainingMillisecondsOnPause?: number | null,
    resume?: string,
};

export const useTimeKeeper = ({ start, duration, remainingMillisecondsOnPause, resume  }: TimeKeeperProps) => {
    const isPaused = !resume && !!remainingMillisecondsOnPause,
        isResumed = !!resume && !!remainingMillisecondsOnPause;

    const calculateEndTime = () =>
        isResumed ?
            dayjs(resume).add(remainingMillisecondsOnPause!, "millisecond") :
            isPaused ?
                dayjs().add(remainingMillisecondsOnPause!, "millisecond") :
                dayjs(start || dayjs()).add(duration, "minute");

    const calculateRemainingTime = () => dayjs.duration(calculateEndTime().diff(dayjs()));

    const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());

    useEffect(() => {
        const tick = () => {
            const calculatedRemainingTime = calculateRemainingTime();
            if ((!isPaused || (isPaused && calculatedRemainingTime.asMilliseconds() !== remainingMillisecondsOnPause))) {
                if (calculatedRemainingTime.asMilliseconds() <= 0) {
                    setRemainingTime(dayjs.duration(0));
                } else {
                    setRemainingTime(calculatedRemainingTime);
                }
            }
        };

        tick();
        const interval = setInterval(tick, TICK_INTERVAL);

        return () => clearInterval(interval);
    }, [start, duration, resume, remainingMillisecondsOnPause]);


    return remainingTime;
};
